@if (fatalErrorState.failed()) {
  <div class="fatal-error-overlay" role="alert">
    <h1 class="fatal-error-overlay-title">{{ i18n.t('diagnostics.fatal.title') }}</h1>
    <p class="fatal-error-overlay-message">
      {{ i18n.t('diagnostics.fatal.message') }}
    </p>
    <button type="button" class="fatal-error-overlay-reload" (click)="reload()">
      {{ i18n.t('diagnostics.reload') }}
    </button>
  </div>
}
